import { useQuery } from "react-query";
import { getAcademicLevels } from "../services/school/academicLevel";
import { PagedRequestType } from "../types/PagedResults";
import { Key_AcademicLevels } from "../utils/constants";

export const useGetAcademicLevelsQuery = (data: PagedRequestType,options:any= null) => {
    return useQuery(
        [Key_AcademicLevels, JSON.stringify(data)],
        () => getAcademicLevels(data),
        options?{...options}:{}
    );
};
